(function () {
  'use strict';

  var timerSelector = '[data-countdown-timer]';
  var intervalId;
  var activeTimers = [];
  var countdownObserver;
  var pacificOffsetFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    timeZoneName: 'shortOffset'
  });

  function pacificTimestamp(dateString, timeString) {
    var dateParts = dateString.split('-').map(Number);
    var timeParts = (timeString || '23:59:59').split(':').map(Number);
    if (dateParts.length !== 3 || dateParts.some(isNaN)) return NaN;

    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];
    var hour = timeParts[0] || 0;
    var minute = timeParts[1] || 0;
    var second = timeParts[2] || 0;
    var utcGuess = Date.UTC(year, month - 1, day, hour, minute, second);
    var parts = pacificOffsetFormatter.formatToParts(new Date(utcGuess));
    var zone = parts.find(function (part) { return part.type === 'timeZoneName'; });
    var offsetMatch = zone && zone.value.match(/GMT([+-]\d+)(?::(\d+))?/);
    var offsetMinutes = offsetMatch ? Number(offsetMatch[1]) * 60 + Number(offsetMatch[2] || 0) : -480;
    return utcGuess - offsetMinutes * 60 * 1000;
  }

  function createTimerState(timer) {
    if (timer.__egCountdownState) return timer.__egCountdownState;

    var end = pacificTimestamp(timer.dataset.endDate || '', timer.dataset.endTime);
    if (Number.isNaN(end)) return null;

    var state = {
      timer: timer,
      end: end,
      isNearViewport: false,
      values: {},
      elements: {
        days: timer.querySelector('[data-days]'),
        hours: timer.querySelector('[data-hours]'),
        minutes: timer.querySelector('[data-minutes]'),
        seconds: timer.querySelector('[data-seconds]')
      }
    };

    timer.__egCountdownState = state;
    activeTimers.push(state);
    var observer = getCountdownObserver();
    state.isNearViewport = !observer;
    if (observer) observer.observe(timer);
    return state;
  }

  function setValue(state, key, value) {
    if (state.values[key] === value) return;
    state.values[key] = value;
    if (state.elements[key]) state.elements[key].textContent = String(value).padStart(2, '0');
  }

  function updateCountdowns() {
    var now = Date.now();
    activeTimers = activeTimers.filter(function (state) {
      if (!state.timer.isConnected) {
        if (countdownObserver) countdownObserver.unobserve(state.timer);
        return false;
      }
      if (!state.isNearViewport) return true;

      var distance = Math.max(0, state.end - now);
      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      setValue(state, 'days', days);
      setValue(state, 'hours', hours);
      setValue(state, 'minutes', minutes);
      setValue(state, 'seconds', seconds);
      if (!distance && countdownObserver) countdownObserver.unobserve(state.timer);
      return distance > 0;
    });

    if (!activeTimers.length && intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  function hasNearViewportTimer() {
    return activeTimers.some(function (state) {
      return state.timer.isConnected && state.isNearViewport;
    });
  }

  function syncCountdownInterval() {
    var shouldRun = !document.hidden && hasNearViewportTimer();

    if (!shouldRun && intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    } else if (shouldRun && !intervalId) {
      intervalId = window.setInterval(updateCountdowns, 1000);
    }
  }

  function getCountdownObserver() {
    if (countdownObserver !== undefined) return countdownObserver;
    if (!('IntersectionObserver' in window)) {
      countdownObserver = null;
      return countdownObserver;
    }

    countdownObserver = new window.IntersectionObserver(function (entries) {
      var timerEnteredRange = false;

      entries.forEach(function (entry) {
        var state = entry.target.__egCountdownState;
        if (!state) return;
        state.isNearViewport = entry.isIntersecting;
        if (entry.isIntersecting) timerEnteredRange = true;
      });

      if (timerEnteredRange) updateCountdowns();
      syncCountdownInterval();
    }, { rootMargin: '1000px 0px' });

    return countdownObserver;
  }

  function initCountdowns(root) {
    var scope = root || document;
    var timers = [];

    if (scope.matches && scope.matches(timerSelector)) timers.push(scope);
    scope.querySelectorAll(timerSelector).forEach(function (timer) { timers.push(timer); });
    timers.forEach(createTimerState);
    if (!activeTimers.length) return;

    updateCountdowns();
    syncCountdownInterval();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      syncCountdownInterval();
      return;
    }

    if (!activeTimers.length) return;
    if (hasNearViewportTimer()) updateCountdowns();
    syncCountdownInterval();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountdowns(document); });
  } else {
    initCountdowns(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initCountdowns(event.target); });
})();
